module.exports = __webpack_public_path__ + "img/1_1-industriale-fabbrica-0.3863c8de.png";